"use client"

import { useState, useEffect } from "react"
import { useTheme } from "../../contexts/ThemeContext"
import MainNav from "../MainNav"
import { Link, NavLink } from "react-router-dom"
import { crudData, doConnexion, doDisConnexion } from "../../services/apiService"
import { Modal, Spinner } from "react-bootstrap"
import { toast } from "react-toastify"
import EncoursComponent from "../Encours/EncoursComponent"
import "./login.css"
import MobileMenu from "../MobileMenu"
import ForgotPasswordModal from "../ForgotPassword/ForgotPassword"
import { useNavigate } from "react-router-dom"; // Ajout jwt 20/04/2026
import SearchBar from "./SearchBar"
import "./SearchBar.css"

const TopBar = ({ param, onComplete, triggerRequest, cartCount, setCartCount }) => {
  const { theme, toggleTheme } = useTheme()
  const [showModal, setShowModal] = useState(false)
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false)
  const userData = JSON.parse(localStorage.getItem("userData"))
  const mode = JSON.parse(localStorage.getItem("appMode"))
  const apiEndpointe = JSON.parse(localStorage.getItem("apiEndpointe"))
  const paths = JSON.parse(localStorage.getItem("appPaths"))
  const [statusCode, setStatusCode] = useState(null)
  const [productData, setProductData] = useState([])
  const [totalAmount, setTotalAmount] = useState(0)
  const [clisolde, setCliSolde] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const [filters, setFilters] = useState()

  const [STR_UTILOGIN, setEmail] = useState("")
  const [STR_UTIPASSWORD, setPassword] = useState("")
  const [IS_ADMIN, setCodeSociete] = useState(0)

  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isCartLoading, setIsCartLoading] = useState(false)
  const [isSearchVisible, setIsSearchVisible] = useState(false)
  const navigate = useNavigate(); // ajout 20/04/2026

  useEffect(() => {
    const authNotif = localStorage.getItem("authNotif")
    if (authNotif) {
      toast.success(authNotif, {
        position: "top-right",
        autoClose: 5000,
      })
      localStorage.removeItem("authNotif")
    }
  }, [])


  // Ajoutez cette fonction dans votre composant TopBar
  const handleSearch = (searchTerm) => {
    console.log("Recherche:", searchTerm)
    window.location.href = `/catalogue?search=${searchTerm}`
  }

  // Fonction pour basculer entre les modals
  const handleShowForgotPassword = (e) => {
    e.preventDefault()
    setShowModal(false) // Ferme le modal de connexion
    setShowForgotPasswordModal(true) // Ouvre le modal de mot de passe oublié
  }

  // Fonction pour revenir au modal de connexion
  const handleShowLogin = () => {
    setShowForgotPasswordModal(false) // Ferme le modal de mot de passe oublié
    setShowModal(true) // Ouvre le modal de connexion
  }

  const handleLogin = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError(null)
    try {
      const params = new URLSearchParams()
      params.append("mode", param.mode.doConnexionMode)
      params.append("STR_UTILOGIN", STR_UTILOGIN)
      params.append("STR_UTIPASSWORD", STR_UTIPASSWORD)
      params.append("IS_ADMIN", IS_ADMIN)

      const response = await doConnexion(params)
      const userData = response.data

      if (userData.code_statut === "1") {
        if (userData.jwt_token) {
          localStorage.setItem("jwt_token", userData.jwt_token);
        } // jwt 20/04/2026
        localStorage.setItem("userData", JSON.stringify(userData))
        localStorage.setItem("authNotif", "Connexion réussie !")

        // Fermer le modal et actualiser la page
        setShowModal(false) // Ferme le modal
        navigate("/"); // ← rediriger vers accueil - 20/04/2026
        window.location.reload() // Actualise la page
      } else {
        setError(userData.desc_statut)
      }
    } catch (error) {
      setError("Erreur de connexion. Veuillez réessayer.")
    } finally {
      setIsLoading(false)
    }
  }

  const fetchPanierData = async (params, url, setTotalAmount) => {
    crudData(params, url)
      .then((response) => {
        console.log(response.data)
        if (response && response.status === 200) {
          onComplete()
        } else {
          console.error("Erreur HTTP:", response)
          setStatusCode(response?.status || "Unknown error")
        }
      })
      .catch((error) => {
        setStatusCode(404)
        console.error("Erreur lors de la récupération des données:", error)
      })
  }

  const fetchData = async (params, url, setProductData, setTotalAmount) => {
    setIsCartLoading(true);
    crudData(params, url)
      .then((response) => {
        console.log(response)
        console.log(url)
        if (response && response.status === 200) {
          const produitVeto = response.data.lines || [] // Ensure it's an array
          const panier = Array.isArray(produitVeto) ? produitVeto : []

          // Calculer le montant total du panier
          const totalAmount = panier.reduce((acc, item) => {
            // Enlever les espaces éventuels et convertir en nombres
            const prixUnitaire = Number.parseFloat(item.PlvPUNet.trim()) || 0
            const quantite = Number.parseFloat(item.PlvQteUV.trim()) || 0
            return acc + prixUnitaire * quantite
          }, 0)
          setCliSolde(response.data.clisolde)
          setProductData(panier)
          setTotalAmount(totalAmount)
          onComplete()
          if (setCartCount) setCartCount(panier.length) // synchronisation du compteur
        } else {
          console.error("Erreur HTTP:", response)
          setStatusCode(response?.status || "Unknown error")
        }
      })
      .catch((error) => {
        setStatusCode(404)
        console.error("Erreur lors de la récupération des données:", error)
      })
      .finally(() => {
        setIsCartLoading(false);
      });
  }

  const fetchGammeAndCategory = async (params, url, setFilters) => {
    crudData(params, url)
      .then((response) => {
        if (response && response.status === 200) {
          const filters = response.data.data || []
          localStorage.setItem("filters", JSON.stringify(filters))
          const newMegaMenu = []
          Object.keys(filters).forEach((item) => {
            const items = []
            filters[item].forEach((element) => {
              items.push({
                label: element,
                href: `/catalogue?${item}=${element}`,
              })
            })
            newMegaMenu.push({
              title: item.toUpperCase(),
              items: items,
            })
          })
          setFilters(newMegaMenu)
        } else {
          console.error("Erreur HTTP:", response)
          setStatusCode(response?.status || "Unknown error")
        }
      })
      .catch((error) => {
        setStatusCode(404)
        console.error("Erreur lors de la récupération des données:", error)
      })
  }

  useEffect(() => {
    if (triggerRequest) {
      const params = {
        mode: mode.listCommandeproductMode,
        LG_AGEID: userData.LG_AGEID,
      }

      fetchData(params, apiEndpointe.CommandeManagerEndPoint, setProductData, setTotalAmount)

      const paramPanier = {
        mode: mode.getExternalClientPanierMode,
        LG_AGEID: userData.LG_AGEID,
      }
      fetchPanierData(paramPanier, apiEndpointe.CommandeManagerEndPoint, setTotalAmount)
      const paramsGammeAndCategory = {
        mode: mode.getProductListGammeAndCategoryMode,
      }
      fetchGammeAndCategory(paramsGammeAndCategory, apiEndpointe.StockManagerEndPoint, setFilters)
    }
  }, [triggerRequest, onComplete]) // The effect will run whenever `quantity` changes

  useEffect(() => {
    //console.log(userData);

    if (userData) {
      // setUser(userData); // Set user in state
      const params = {
        mode: mode.listCommandeproductMode,
        LG_AGEID: userData.LG_AGEID,
      }
      fetchData(params, apiEndpointe.CommandeManagerEndPoint, setProductData, setTotalAmount)
    }
  }, [])

  useEffect(() => {
    const paramsGammeAndCategory = {
      mode: mode.getProductListGammeAndCategoryMode,

    }
    fetchGammeAndCategory(paramsGammeAndCategory, apiEndpointe.StockManagerEndPoint, setFilters)
  }, [])

  const handleChangeTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light"
    toggleTheme(newTheme)
  }

  const handleLogout = async () => {
    try {
      const params = new URLSearchParams()
      params.append("mode", "doDisConnexion")
      params.append("STR_UTITOKEN", param?.userData.STR_UTITOKEN)

      // Attendre la réponse de la fonction de déconnexion
      const response = await doDisConnexion(params)
      const userData = response.data

      if (userData.code_statut === "1") {
        if (localStorage.getItem("userData")) {
          // Suppression de 'userData' si présent dans le localStorage
          localStorage.removeItem("userData")
          localStorage.removeItem("jwt_token"); // ← supprimer le JWT 20/04/2026
          console.log("userData supprimé du localStorage")
        }
        localStorage.setItem("authNotif", "Déconnexion réussie !")
        window.location.replace("/")

        // Actualise la page
      } else {
        setError(userData.desc_statut)
      }
    } catch (error) {
      console.error("Erreur de déconnexion:", error)
    }
  }

  const handleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <>
      <header className={`header header-border ${param.userData ? "bgUserConnected" : ""}`}>
        <div className="header-middle">
          <div className="container" style={{ flexWrap: "wrap", justifyContent: "space-between" }}>
            <div className="header-left mr-md-4">
              <a href="#" className="mobile-menu-toggle  w-icon-hamburger" aria-label="menu-toggle"></a>
              <Link to="/" className="logo ml-lg-0">
                <img src="assets/images/LOGO_SNP_Fond_Transparent.png" alt="logo" width={144} height={45} />
              </Link>

              {param.userData ? (
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  maxWidth: "600px",
                  margin: "0 auto",
                  marginLeft: "90px",
                }}>
                  <EncoursComponent totalAmount={totalAmount} isLoading={isCartLoading} />
                  {isSearchVisible && (
                    <div style={{
                      marginTop: "10px",
                      width: "400px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginLeft: "200px",
                    }}>
                      <SearchBar onSearch={handleSearch} />
                    </div>
                  )}
                </div>
              ) : <></>}




            </div>
            {/* {param.userData ? <EncoursComponent totalAmount={totalAmount} /> : <></>} */}
            <div className="header-right ml-4">
              {param.userData ? (
                <>
                  <nav className="main-nav text-center">
                    <ul className="menu ">
                      <li className="">
                        <div
                          className="wishlist label-down link d-xs-show"
                          onClick={() => setIsSearchVisible(!isSearchVisible)}
                          style={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            marginRight: "2.3rem",
                          }}
                        >
                          <i className="w-icon-search" />
                          <span className="cart-label" style={{ fontWeight: "bold", marginTop: "0.5rem" }}>
                            Rechercher
                          </span>
                        </div>
                      </li>
                      <li className="">
                        <div
                          className="wishlist label-down link d-xs-show"
                          style={{
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                        >
                          <i className="w-icon-account" />
                          {/**  d-lg-show fs_header_1_4rem*/}
                          <span
                            className=""
                            style={{
                              margin: "0.5rem 0 0",
                              maxWidth: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "inline-block",
                            }}
                            title={param.userData.STR_UTIFIRSTLASTNAME}
                          >
                            {param.userData.STR_UTIFIRSTLASTNAME}
                          </span>
                        </div>
                        <ul className="submenu text-left">
                          <li style={{}}>
                            <button
                              onClick={handleLogout}
                              style={{
                                color: "#3656a1",
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                background: "white",
                                border: "none",
                                fontSize: "inherit",
                                cursor: "pointer",
                                width: "100%",
                                textAlign: "left",
                                borderBottom: "2px solid #3656a1",
                              }}
                            >
                              <i className="w-icon-logout"></i> Deconnexion
                            </button>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </nav>
                  <div className="dropdown cart-dropdown cart-offcanvas" style={{ marginRight: "2.3rem" }}>
                    {/* <a className="cart-toggle label-down link"> */}
                    <NavLink className="cart-toggle label-down link" to={"/panier"}>
                      <i className="w-icon-cart">
                        <span className="cart-count">
                          {cartCount !== undefined && cartCount !== null
                            ? cartCount
                            : productData && productData.length}
                        </span>
                        {/* <span className="cart-count">{productData && productData.length}</span> */}
                      </i>
                      <span className="cart-label" style={{ fontWeight: "bold" }}>
                        Panier
                      </span>
                    </NavLink>

                    {/* </a> */}
                  </div>
                  <div className="dropdown cart-dropdown cart-offcanvas mr-lg-0">
                    {/* <a className="cart-toggle label-down link"> */}
                    <NavLink
                      className="cart-toggle label-down link"
                      to={"/importation"}
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                    >
                      <i
                        className="w-icon-download"
                        style={{
                          fontWeight: "bold",
                        }}
                      ></i>
                      <span className="cart-label" style={{ fontWeight: "bold" }}>
                        Importer
                      </span>
                    </NavLink>

                    {/* </a> */}
                  </div>
                </>
              ) : (
                <div className="circle mx-4">
                  <div className="text">
                    <p className="mb-1 sign-text">Accès Membre</p>
                    <p className="mb-1 text-small-desc mt-1">
                      Pour accéder à nos prix <br />
                      et commander en ligne
                    </p>
                  </div>
                  <button className="btn fs-20" onClick={() => setShowModal(true)}>
                    S'identifier
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* End of Header Middle */}
        <Modal size="lg" show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Body>
            <div className="row justify-content-center flex-wrap">
              <div className="login-container">
                <div className="login-left">
                  <h1 className="">
                    <span className="highlight">Hello !</span> nous sommes heureux de vous revoir
                  </h1>
                  <p className="text-center">Pour vous connecter renseignez votre identifiant</p>
                  {error && (
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  )}
                  <form onSubmit={handleLogin}>
                    <div className="input-group height-updated">
                      <input
                        type="text"
                        id="email"
                        placeholder="Login"
                        value={STR_UTILOGIN}
                        onChange={(e) => setEmail(e.target.value)}
                        className="input-field"
                      />
                    </div>

                    <div className="input-group height-updated">
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Mot de passe"
                        value={STR_UTIPASSWORD}
                        onChange={(e) => setPassword(e.target.value)}
                        className="input-field"
                      />
                      {showPassword ? (
                        <svg
                          onClick={handleShowPassword}
                          className="password-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          width={24}
                          height={24}
                        >
                          <path d="M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z"></path>
                        </svg>
                      ) : (
                        <svg
                          onClick={handleShowPassword}
                          className="password-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          width={24}
                          height={24}
                        >
                          <path d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"></path>
                        </svg>
                      )}
                    </div>
                    <div className="options" style={{ marginBottom: "25px" }}>
                      {/* <label>
                        <input type="checkbox" /> Rester connecté
                      </label> */}
                      <a href="#" onClick={handleShowForgotPassword}>
                        Mot de passe oublié ?
                      </a>
                    </div>
                    <button type="submit" className="btn btn-submit" disabled={isLoading}>
                      {isLoading ? (
                        <>
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                          <span style={{ marginLeft: "8px" }}>Connexion en cours...</span>
                        </>
                      ) : (
                        "S'identifier"
                      )}
                    </button>
                  </form>
                  <p className="signup">
                    Pas encore de compte ?{" "}
                    <NavLink
                      to={"/saveclient"}
                      onClick={() => setShowModal(false)}
                    >
                      Créer un compte
                    </NavLink>
                  </p>
                </div>
                <div className="login-right d-none d-md-block">
                  <div className="company-info">
                    <img src="/assets/images/logo-blanc.png" alt="SN Proveci Logo" className="company-logo" />
                    <h2 className="highlight">GROSSISTE VÉTÉRINAIRE</h2>
                    <p>
                      En tant que client bénéficiez d'un accompagnement personnalisé, commandez en ligne, accédez à des
                      offres préférentielles
                    </p>
                  </div>
                  <div className="animal-icons">
                    <img src="assets/images/icone.png" alt="Icon" />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Modal de mot de passe oublié */}
        <ForgotPasswordModal
          show={showForgotPasswordModal}
          onHide={() => setShowForgotPasswordModal(false)}
          showLoginModal={handleShowLogin}
        />

        <MainNav param={param} megaMenu={filters} />
        <MobileMenu megaMenu={filters} />
      </header>
    </>
  )
}

export default TopBar

